module.exports = __webpack_public_path__ + "img/app_download.491d979c.png";